/**
 * Sistema ajax para las páginas de archivo que contienen filtros
 * (si no hay filtros, la paginación es la de wp-pagenavi por defecto).
 *      - Si se actualiza el formulario de filtros, se recogen los filtros 
 *      y se realiza la consulta para obtener la pág. 1 de los datos filtrados
 *      - Si se pulsa en el sistema de paginación, se recogen los datos del
 *      formulario de filtros, la página deseada y se realiza la consulta
 */


(function($){

    let mainContainers = $('.lnm-archive__main--has-filters');

    if( !mainContainers || mainContainers.length < 1 ){
        return;
    }

    mainContainers.each(function(){
        initFilteredPagination( $(this) );
    })


    /**
     * Función principal. Se ejecuta por cada uno de los bloques de cards
     * con paginación y filtros asociados
     */
    function initFilteredPagination( mainContainer ){

        // Variables
        let cardsContainer = mainContainer.find('.lnm-archive__cards');
        let filtersForm = mainContainer.find('.lnm-archive-filters__form');
        let headerHeight = $('.lnm-site-header').outerHeight();       

        // Eventos
        filtersForm.on('change', function(){
            let formData = filtersForm.serialize();
            let page = window.location.href + 'page/1/';

            sendAjaxRequest(formData,page);
        })

        cardsContainer.on('click', 'a.page-numbers', function(e){
            e.preventDefault();

            let formData = filtersForm.serialize();
            let page = $(this).attr('href');

            sendAjaxRequest(formData,page);
        })


        // consulta Ajax
        function sendAjaxRequest( formData, page ){

            $.ajax({

                type: "POST",
                dataType: "html",
                url: var_lnm_ajax.url,
                data: {
                    action      : var_lnm_ajax.action,
                    nonce       : var_lnm_ajax.nonce,
                    callback    : 'lnm_archive_filter_pagination',
                    formData    : formData,
                    page        : page
                },

                success: function(data){

                    if(data.length){
                        cardsContainer.html(data);

                        $([document.documentElement, document.body]).animate({
                            scrollTop: cardsContainer.offset().top - headerHeight - 40
                        }, .5);

                    }else{

                        let feedback =  '<div class="lnm-archive__no-filtered-results">' +
                                        '<p>No se han encontrado resultados que coincidan con los filtros seleccionados. Prueba eliminando alguno de los filtros</p>' +
                                        '</div>';

                        cardsContainer.html(feedback);
                    }

                },
                error : function(jqXHR, textStatus, errorThrown) {
                    console.log('error');
                }

            }); // $.ajax()

        }; // sendAjaxRequest()

    } // initFilteredPagination()

})(jQuery)